<div class="product-notes-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Product Notes</p>
    <div class="hero-layout">
      <div>
        <h1>Product Notes</h1>
        <div class="meta-badges">
          <span>Food &amp; Drink</span>
          <span>Android</span>
          <span>Kotlin</span>
          <span>Barcode scanner</span>
        </div>
      </div>
      <div class="app-mark" aria-hidden="true">
        <span class="app-mark-bar"></span>
        <span class="app-mark-dot"></span>
        <span class="app-mark-line"></span>
      </div>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Product Notes is a simple Android app for remembering which food and drink products
        work for you. Scan a barcode, add a personal review, and make a confident choice the
        next time you see the product in a shop.
      </p>

      <ul class="feature-list">
        <li>Scan a product barcode or enter it manually.</li>
        <li>Save a personal rating and notes for each product.</li>
        <li>Review your own recommendations before buying again.</li>
        <li>Switch between light and dark themes.</li>
      </ul>

      <a class="project-link" target="_blank" rel="noopener"
         href="https://play.google.com/store/apps/details?id=pl.jawegiel.productsnotes&hl=en">
        Download on Google Play
      </a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1735987424_2.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1735988095.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1735988163_2.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1735988385_2.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1735988174.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/Screenshot_1736010755_2.png" alt="Endless Blow screenshot">
    </aside>
  </div>
</div>
